import { useEffect } from "react";
import { useAuth, type Auth } from "../../store/useAuthStore";
import { useLoginStore } from "../../store/useLoginStore";
import { useAuthInfo } from "../apis/hooks/auth.hook";
import { useQuery } from "@tanstack/react-query";

export default function useRefreshAuth() {
  const { access } = useLoginStore();
  const setAuth = useAuth((state) => state.setAuth);

  const { data, isSuccess } = useQuery({ ...useAuthInfo(), enabled: !!access.accessToken });

  useEffect(() => {
    if (isSuccess && !data.error) {
      const userResponse = data?.result;
      const role = data?.result.role;


      const auth = {
        id: userResponse?.userId,
        ownerId: userResponse?.ownerId,
        phone: userResponse?.phone,
        stores: userResponse?.stores,
        username: userResponse?.username,
        role: role,
        createdDate: userResponse?.createDate,
        activeStoreNum: userResponse?.activeStoreNum,
      } as unknown as Auth;
      setAuth(auth);
    }
  }, [isSuccess, setAuth])
}
